// Set axios defaults to use for each request
import axios from 'axios';
axios.defaults.baseURL = indexJSVars.ajaxurl;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

import './animations/fadeInOnScroll';

// Import main scss file here. This will compile to a css file in the dist folder
import '../scss/style.scss';
